// extracted by mini-css-extract-plugin
module.exports = {"talk":"s-module--talk--10lBn","author":"s-module--author--XlpBh","title":"s-module--title--2Ho8J"};